import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import generateTestId from 'utils/test-helpers'

interface Props {
  value: string
  label: string
  count?: number
  isActive: boolean
  onClick: (value: string) => void
}

export default function TabPreview({ label, value, isActive, onClick, count }: Props) {
  const classes = useStyles()
  return (
    <div className={classes.tabPreview} onClick={() => onClick(value)}>
      <Text
        className={clsx(classes.tabText, { [classes.tabTextActive]: isActive })}
        data-testid={generateTestId(label, 'tab')}
        variant="subtitle2"
      >
        {label} {count !== undefined ? `(${count})` : ''}
      </Text>
      {isActive && <span className={classes.activeBorder} />}
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  tabPreview: {
    height: 35,
    display: 'grid',
    gap: 8,
    gridAutoFlow: 'row',
    cursor: 'pointer',
  },
  tabText: {
    padding: '0 16px',
    color: theme.components.tab.text,
    '&:hover': {
      color: theme.components.tab.activeText,
    },
  },
  tabTextActive: {
    color: theme.components.tab.activeText,
  },
  activeBorder: {
    height: 4,
    display: 'grid',
    borderRadius: 1.5,
    margin: 0,
    padding: 0,
    background: theme.components.tab.activeBackground,
  },
}))
